<template>
  <div id="tips" class="span-tips span-full bgblack" data-type="layout">
    <div class="full-inner span-blocks span-3">
      <div class="item figure" v-bind:class="direction[Math.floor(Math.random()*direction.length)]" v-for="(item,key) in tips">
        <div class="face flip item-content pl3 pr3" v-bind:class="'bg'+item.background_color">
          <h3>{{item.title}}</h3>
        </div>
        <div class="face flop item-bg" v-bind:class="'bg'+item.background_color">
          <div class="item-icon" v-bind:class="'icon-slider-'+parseInt(key)"></div>
        </div>
      </div>
    </div>
    <a href="#" data-index="2" class="read-more">
      <span class="arrow-down"></span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'solution-tips',
  data() {
    return {
      direction: ['vertical','horizontal'],
      tips: [],
      shuffled: []
    }
  },
  methods: {
    getUrl(){
      this.tips = []
      if( localStorage.getItem('language') === 'en' ){
        return process.env.site.url + '/wp-json/wp/v2/pages?slug=solutions-tips'
      } else {
        return process.env.site.url + '/wp-json/wp/v2/pages?slug=soluciones-tips&lang=es'
      }
    },
    loadContent(){
        var getUrl = this.getUrl()
        window.removeEventListener('scroll', this.fadeLayoutIn )

        this.axios.get(this.getUrl()).then((response) => {
          var page = response.data[0].acf
          this.tips = page.tips
        })
      }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted(){
    this.$nextTick( () => {
      this.loadContent()
    })
  },
}
</script>


// WEBPACK FOOTER //
// Solutions-tips.vue?bd98ef50